import { makeStyles, Theme } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

type MakeStylesArgs = { color: "grey" | "blue"; ffairNameColor?: string };

export default makeStyles<Theme, MakeStylesArgs>((theme) => ({
  root: {
    display: "flex",
    color: grey[400],
    alignItems: "center",
  },
  boldText: ({ color, ffairNameColor }) => {
    if (ffairNameColor) {
      return {
        fontWeight: 500,
        color: ffairNameColor,
      };
    }
    return {
      fontWeight: 500,
      color: color === "blue" ? theme.palette.common.black : grey[400],
    };
  },
}));
